module.exports = __webpack_public_path__ + "static/media/border-center-v.f7e36367.svg";